module.exports = __webpack_public_path__ + "img/company.fc4f0f48.png";